import {useEffect, useState} from 'react';
import {Modal, Button, Form, Input, Switch,  Popconfirm, message} from 'antd';
import {useApi} from "../provider/ApiProvider";

const layout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 16 },
};

const {TextArea} = Input;

export default function PlatformDialog({open, data, onChange, onClose}){

    const {api} = useApi();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        console.log(data, 'dataa');
        form.setFieldsValue(data);
    },[data])

    const handleOk = () => {

    };

    const handleCancel = () => {
        onClose()
    };

    const onFinish = (values) => {
        if(data === null){
            setLoading(true);
            api.post("/platformRouter/platform/store",values).then(resp => {
                onClose();
                onChange();
                setLoading(false);
            }).finally(() => {
                setLoading(false);
            })
        }else{
            setLoading(true);
            api.put("/platformRouter/platform/update/" + data.id,values).then(resp => {
                onClose();
                onChange();
                setLoading(false);
            }).finally(() => {
                setLoading(false);
            })
        }

    };

    const onFinishFailed = (errorInfo) => {

    }

    const onDelete = (record) => {


    }



    return (
        <Modal
            title={(data === null || data === undefined) ? "Platform Ekle" : "Düzenle"}
            visible={open} okType={"submit"}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
                <Button  key="back" onClick={handleCancel}>
                    İptal
                </Button>,


                <Button  form="company-dialog-form" htmlType="submit" key="submit" type="primary" loading={loading} onClick={handleOk}>
                    Kaydet
                </Button>,
            ]}
        >
            <Form
                form={form}
                id="company-dialog-form"
                onFinish={onFinish}
                onFinishFailed={() => onFinishFailed("İstenen bilgileri giriniz")}
                initialValues={data}
            >
                <Form.Item
                    label="Adı"
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: 'Bu alanı doldurunuz',
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="Alt Müşteriler Görünsün mü?"
                    name="isShowCustomers"
                    rules={[
                        {
                            required: true,
                            message: 'Bu alanı doldurunuz',
                        },
                    ]}
                >
                    <Switch defaultChecked={data?.isShowCustomers} />
                </Form.Item>
                <Form.Item
                    label="Uygulamada Görünsün mü?"
                    name="showApp"
                    rules={[
                        {
                            required: true,
                            message: 'Bu alanı doldurunuz',
                        },
                    ]}
                >
                    <Switch defaultChecked={data?.showApp} />
                </Form.Item>


            </Form>
        </Modal>

    )
}
